import UButton from "../../../Button/UButton/UButton";
import DeleteRequest from "../../../Modal/ModalConditions/Requests/DeleteRequest/DeleteRequest";
import RequestServices from "../../../../../frontend.services/RequestServices/RequestServices";
import { isTerminal } from "../../../../../constants";
import { ScrollButton } from "../../../componentsTerminal/ScrollButton/ScrollButton";

import {
    unsetCurrentDocumentAction,
} from "../../../../../redux/actions/Requests/CurrentRequest/setCurrentDocument.action";
import {
    deleteIndividualCoefficientThunkAction,
} from "../../../../../redux/actions/Requests/RequestsFromLeader/IndividualCoefficients/deleteIndividualCoefficientThunkAction";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import moment from "moment";

isTerminal
    ? import("./IndividualCoefficientsModalTerminal.scss")
    : import("./IndividualCoefficientsModal.scss");

function formatNumber(value) {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return "";
    return new Intl.NumberFormat("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
}

// Подсветка согласующего, чей ход сейчас — как в CurrentRequestCard: следующий ещё не подписал,
// значит текущий согласующий "активен" (жирный чёрный); тех, кого уже обошли, гасим серым.
// Когда заявка в финальном статусе "Исполнена" — весь список гасим (аналог status >= 6 в CurrentRequestCard).
function getApproverClassName(approvers, index, requestStatus) {
    if (requestStatus === "Исполнена") {
        return "approvers__passive";
    }

    const current = approvers[index];
    const next = approvers[index + 1];
    if (next) {
        return next.assignmentDate ? "approvers__passive" : "approvers__active";
    }
    return current.assignmentDate ? "approvers__active" : "approvers__normal";
}

const IndividualCoefficientsModal = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const currentDocument = useSelector((state) => state.requests.singleDocument);
    const [loader, setLoader] = useState(false);
    const [deleteRequest, setDeleteRequest] = useState(null);

    useEffect(() => {
        return () => {
            dispatch(unsetCurrentDocumentAction());
        };
    }, []);

    if (!currentDocument) {
        return (
            <div className="request-modal-loader">
                <ClipLoader color="#6DCDF6" />
            </div>
        );
    }

    const request = currentDocument.currentRequest || {};
    const card = currentDocument.currentRequestCard || {};
    const rows = request.rows || [];
    const totals = request.totals || {};
    const isDraft = request.status === "Draft";

    function goToEdit() {
        navigate("/main/hr-services/requests/leader/22");
        props.close();
    }

    function deleteHandler() {
        dispatch(
            deleteIndividualCoefficientThunkAction(request.uid, {
                setState: setLoader,
                setDeleteState: setDeleteRequest,
            }),
        );
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "48px", flex: 1, overflow: "hidden", minHeight: 0 }}>
            {isTerminal && <ScrollButton propsClassName={".request-modal__table"} />}
            {
                loader
                    ? (<div style={{ margin: "auto", textAlign: "center", width: "400px" }}>
                        <ClipLoader color="#6DCDF6" />
                    </div>)
                    : deleteRequest
                        ? (<DeleteRequest close={props.close} deleteRequest={deleteRequest} />)
                        : (<>
                            <div className="request-modal__table">
                                {
                                    // "Наименование" не выводим строкой — оно уже стоит в заголовке модалки
                                    Object.keys(card).filter((key) => key !== "Наименование").map((key, index) => (
                                        <div key={index} className="request-modal__table__line">
                                            <div className="left-column">{key}</div>
                                            <div className="right-column">{card[key]}</div>
                                        </div>
                                    ))
                                }

                                {
                                    request.approvers && request.approvers.length !== 0 && (
                                        <div className="request-modal__table__line">
                                            <div className="left-column">
                                                ФИО согласующего/
                                                <br />
                                                дата поступления
                                            </div>
                                            <div className="right-column">
                                                {request.approvers.map((el, i) => (
                                                    <div className="approvers" key={i}>
                                                        <span className={getApproverClassName(request.approvers, i, request.status)}>
                                                            {el.lastName}{" "}
                                                            {el.firstName ? `${el.firstName[0]}.` : ""}
                                                            {el.secondName ? `${el.secondName[0]}.` : ""}
                                                        </span>
                                                        <span className={getApproverClassName(request.approvers, i, request.status)}>
                                                            {
                                                                el.statusText ||
                                                                (el.assignmentDate
                                                                    ? moment(el.assignmentDate).format("DD.MM.YYYY")
                                                                    : "")
                                                            }
                                                        </span>
                                                        {el.statusNote && (
                                                            <span className="approvers__comment">{el.statusNote}</span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    request.attachments && request.attachments.length !== 0 && (
                                        <div className="request-modal__table__line">
                                            <div className="left-column">
                                                документы
                                            </div>
                                            <div className="right-column">
                                                {request.attachments.map((el, i) => (
                                                    <div key={i}>
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                        <a
                                                            style={{ cursor: "pointer" }}
                                                            target="_blank"
                                                            onClick={() => RequestServices.downloadRequestFile(el)}
                                                            className="custom-uploader__item__name"
                                                            rel="noreferrer">
                                                            {el.fileName}
                                                        </a>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="ic-doc-modal__rows">
                                    <table className="ic-doc-modal__table">
                                        <thead>
                                            <tr>
                                                <th>Таб. №</th>
                                                <th>Должность</th>
                                                <th>ФИО работника</th>
                                                <th>Базовая сумма премии (ПКВ), ₽</th>
                                                <th>Мотивация (+/- в ₽)</th>
                                                <th>Расчетная сумма к начислению, ₽</th>
                                                <th>  KI Коэффициент</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((row) => (
                                                <tr key={row.prid}>
                                                    <td>{row.personnelNumber}</td>
                                                    <td>{row.positionName}</td>
                                                    <td>{row.fullName}</td>
                                                    <td className="ic-doc-modal__num">
                                                        {formatNumber(row.baseBonusAmount)}
                                                    </td>
                                                    <td className="ic-doc-modal__num">
                                                        {formatNumber(row.motivationAmount)}
                                                    </td>
                                                    <td className="ic-doc-modal__num">
                                                        {formatNumber(row.calculatedAmount)}
                                                    </td>
                                                    <td className="ic-doc-modal__num">
                                                        {formatNumber(row.individualCoefficient)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="ic-doc-modal__totals">
                                                <td colSpan={3}>Итого:</td>
                                                <td className="ic-doc-modal__num">
                                                    {formatNumber(totals.baseBonusAmount)}
                                                </td>
                                                <td className="ic-doc-modal__num">
                                                    {formatNumber(totals.motivationAmount)}
                                                </td>
                                                <td className="ic-doc-modal__num">
                                                    {formatNumber(totals.calculatedAmount)}
                                                </td>
                                                <td className="ic-doc-modal__num">—</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                            {
                                !props.isLeader && (
                                    <div className="buttons-wrapper">
                                        {
                                            isDraft && (
                                                <UButton
                                                    className="request-modal__button"
                                                    onClick={goToEdit}>
                                                    редактировать
                                                </UButton>
                                            )
                                        }
                                        <UButton
                                            className="request-modal__button"
                                            onClick={deleteHandler}
                                            disabled={!isDraft}>
                                            удалить заявку
                                        </UButton>
                                    </div>
                                )
                            }
                        </>)
            }
        </div>
    );
};

export default IndividualCoefficientsModal;
